import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useTagBySlug } from '../hooks/useTagBySlug';
import { useTagBookmarks } from '../services/dataHooks';

export const Route = createFileRoute('/_app/tags/$slug/read/$id')({
  component: TagsReadPage,
});

function TagsReadPage() {
  const { slug } = Route.useParams();
  const { preferences } = useUserPreferences();
  const { bookmarks, isLoading: isBookmarkCollectionLoading } = useTagBookmarks(slug, 1);
  const currentTag = useTagBySlug(slug);

  return (
    <BookmarkListPage
      mode="tags"
      bookmarks={bookmarks}
      currentTag={currentTag}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
    />
  );
}
